var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormulateForm',{attrs:{"schema":_vm.schema},on:{"submit":_vm.onSubmit},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }